import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { OrganizationsService } from '@evc/platform';
import { CurrentUserService } from '@core/services/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationGuard {
  #router = inject(Router);
  #currentUserService = inject(CurrentUserService);
  #organizationsService = inject(OrganizationsService);

  public async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const routeOrgId: string = route.params.orgId;
    if (!routeOrgId) {
      return false; // The guard is required to be used on routes with orgId param.
    }
    // If the user is not set, we can't determine if they have access to the organization or not, so we redirect them.
    const currentUser = this.#currentUserService.currentUser();
    if (!currentUser) {
      return this.#router.createUrlTree(['/user-redirect'], {
        queryParams: {
          returnUrl: state.url,
        },
      });
    }
    const currentOrgId = currentUser.organizationId;
    if (routeOrgId === currentOrgId) {
      return true;
    }

    const hasAccessToOrganization = this.#organizationsService.entries().some(org => org.id === routeOrgId);
    return this.#router.createUrlTree(['/wrong-organization'], {
      queryParams: {
        targetOrgId: routeOrgId,
        hasAccess: String(hasAccessToOrganization),
        returnUrl: state.url,
      },
    });
  }
}
